import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ApiPaths } from "../../Config/ApiPath";
import useAxiosHelper from "../../Common/AxiosHelper";
import { toastFailed, toastSuccess } from "../../Config/BasicInfo";
const WaitingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const { AxiosPost } = useAxiosHelper();
  const [trasnsactionId, setTransactionId] = useState();
  const { paymentUrl, orderId } = location.state || {};
  console.log(paymentUrl, orderId, "...");
  let x = 0;

  useEffect(() => {
    if (x === 0) {
      if (paymentUrl) {
        window.open(paymentUrl, "_blank");
      } else {
        navigate("/fund");
      }
      x = 1;
    }
  }, []);
  async function handlemanualApi() {
    try {
      setLoading(true);

      const body = {
        transaction_id: orderId,
      };
      console.log(body, "...waiting body");
      const response = await AxiosPost(ApiPaths.getManualRequest, body);
      console.log(response);
      toastSuccess(response?.message);
      navigate("/dashboard");
    } catch (e) {
      console.log(e);
      toastFailed(e?.message);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div>
      <div style={{ textAlign: "center", paddingTop: "50px", color: "white" }}>
        <h1>Processing Payment...</h1>
        <p>Please wait while we redirect you to the payment gateway.</p>
      </div>

      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: "#f5c518",
            border: "none",
            borderRadius: "5px",
            color: "white",
            fontSize: "16px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#f5c518")}
          onClick={handlemanualApi}
        >
          Click here after Payment
        </button>
      </div>
    </div>
  );
};

export default WaitingPage;
